import { DynamicComponent } from 'src/@fake-db/dashboard';
import { DashboardObjectComponent } from 'src/models/account';

export default (components: DashboardObjectComponent[]): DynamicComponent[] => {
  if (!components) return [];

  return components.map((component: DashboardObjectComponent) => ({
    i: component.dashboardComponentId ?? '',
    x: Number(component.widgetXPosition) ?? 0,
    y: Number(component.widgetYPosition) ?? 0,
    w: Number(component.widgetWidth) ?? 0,
    h: Number(component.widgetHeight) ?? '',
    minW: Number(component.dashboardWidget?.minWidth ?? 1),
    maxW: Number(component.dashboardWidget?.maxWidth ?? Infinity),
    minH: Number(component.dashboardWidget?.minHeight ?? 1),
    maxH: Number(component.dashboardWidget?.maxHeight ?? Infinity),
    type: component.dashboardWidget?.componentName ?? '',
    title: component.dashboardWidget?.description ?? '',
    static: component?.isStatic ?? false,
    isBound: true,
    isResizeable: component.dashboardWidget?.isResizeable,
    version: component?.version ?? '',
    dashboardWidgetId: component?.dashboardWidget?.widgetId ?? ''
  }));
};
